// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__kqo2I","loginBtn":"header_loginBtn__lQb6v","menu":"header_menu__X_vut","auth":"header_auth__jVzCr"};